import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { firstValueFrom, map, Observable, take } from 'rxjs';

import { Session } from '../models/session.school.model';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root',
})
export class SchoolSessionService {
  http = inject(HttpClient);
  afs: AngularFirestore = inject(AngularFirestore);
  utilsService = inject(UtilsService);

  constructor() {}

  getSessionById(groupId: string, id: string): Observable<Session> {
    const doc = this.afs
      .collection('groups')
      .doc(groupId)
      .collection('sessions')
      .doc(id)
      .get();
    return doc.pipe(
      take(1),
      map((doc) => {
        return { ...doc.data(), id: id } as Session;
      }),
    );
  }

  async create(groupId: string, session: Session): Promise<string> {
    // console.log('SessionService:: create:', JSON.stringify(session, null, 2));
    const doc = await this.afs
      .collection('groups')
      .doc(groupId)
      .collection('sessions')
      .add(session);
    return doc.id;
  }

  async update(
    groupId: string,
    sessionId: string,
    session: Session,
  ): Promise<void> {
    // console.log(
    //   `SessionService:: update: ${sessionId}: `,
    //   JSON.stringify(session, null, 2)
    // );
    return this.afs
      .collection('groups')
      .doc(groupId)
      .collection('sessions')
      .doc(sessionId)
      .update(session);
  }

  async delete(groupId: string, sessionId: string): Promise<void> {
    return this.afs
      .collection('groups')
      .doc(groupId)
      .collection<Session>('sessions')
      .doc(sessionId)
      .delete();
  }

  async getTotalSessions({
    groupId,
    academicYear,
    gradeId,
  }: {
    groupId: string;
    academicYear: number;
    gradeId: string;
  }): Promise<number | undefined> {
    const snapshot = await firstValueFrom(
      this.afs
        .collection('groups')
        .doc(groupId)
        .collection('session_stats')
        .doc(`${gradeId}_${academicYear}`)
        .get()
        .pipe(take(1)),
    );
    // console.log(
    //   `SessionService:: getTotalSessions: ${gradeId}_${academicYear} - ${snapshot.exists}`
    // );
    if (!snapshot.exists) return undefined;
    const data = snapshot.data();
    // console.log(
    //   `SessionService:: getTotalSessions: ${groupId} - ${academicYear} - ${gradeId} - ${JSON.stringify(
    //     data
    //   )}`
    // );
    const total_sessions =
      (data?.['open_sessions'] ?? 0) + (data?.['closed_sessions'] ?? 0);
    return total_sessions ?? undefined;
  }
}
